module.exports = __webpack_public_path__ + "static/media/custom-ex-2.73fe0af5.jpg";